module.exports = __webpack_public_path__ + "img/folder.b63e9f6c.png";